/**********************
 * Styles (plain CSS) — unchanged from your file
 *********************/
const baseCss = `
:root { --ink:#0f172a; --muted:#64748b; --line:#e5e7eb; --bg:#f7f9fc; --brand:#0f172a; --badge:#0ea5e9; }
*{box-sizing:border-box}
body{margin:0}
.jh-root{min-height:100vh;background:linear-gradient(#ffffff,var(--bg))}
.jh-container{max-width:1120px;margin:0 auto;padding:35px}
.jh-section{padding-top:35px;padding-bottom:24px}
.jh-section-head{margin-bottom:16px}
.jh-title{font-size:25px;font-weight:700;color:var(--ink);margin:0 0 30px 0}
.jh-sub{color:var(--muted);margin-top:6px}

/* Home banner */
.jh-banner{width:100%;aspect-ratio:16/9;overflow:hidden;background:#0f172a}
.jh-banner-video{width:100%;height:100%;object-fit:cover;display:block}

.jh-section:has(.jh-banner){padding-top:0}

/* Header */
.jh-header{position:sticky;top:0;background:#fff;border-bottom:1px solid var(--line);z-index:50}
.jh-header--scrolled{background:rgba(255,255,255,.95);backdrop-filter:saturate(180%) blur(12px)}
.jh-header-inner{position:relative;display:flex;align-items:center;justify-content:space-between;height:72px;padding:0 24px}
.jh-header-left{flex:1}
.jh-brand{font-weight:800;color:var(--ink);text-decoration:none;font-size:20px;letter-spacing:.06em;line-height:1}
.jh-brand--center{position:absolute;left:50%;transform:translateX(-50%)}
.jh-nav{display:flex;gap:18px;align-items:center}
.jh-nav--right{margin-left:auto}
.jh-navlink{color:var(--ink);text-decoration:none;background:none;border:none;cursor:pointer;font-size:13px;line-height:1.1;font-weight:500;letter-spacing:.01em;font-family:inherit}
.jh-cart{display:inline-flex;align-items:center;gap:6px;color:var(--ink);text-decoration:none;font-size:13px;line-height:1.1;font-weight:500;letter-spacing:.01em;font-family:inherit}
.jh-badge{display:inline-block;min-width:auto;padding:0;height:auto;border-radius:0;background:transparent;color:var(--ink);text-align:left;font-size:14px;line-height:1;font-weight:900;letter-spacing:.02em}

@media (max-width:960px){
  .jh-header-inner{height:auto;padding:12px 16px;flex-direction:column;align-items:center;gap:12px}
  .jh-header-left{display:none}
  .jh-brand--center{position:static;left:auto;transform:none}
  .jh-nav{flex-wrap:wrap;justify-content:center;gap:12px}
  .jh-nav--right{margin-left:0}
}

/* Grid Cards */
.jh-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:24px;list-style:none;padding-left:0;margin:0}
@media(min-width:640px){.jh-grid{grid-template-columns:repeat(3,1fr)}}
@media(min-width:992px){.jh-grid{grid-template-columns:repeat(4,1fr)}}
.jh-card{display:block;background:#fff;border:1px solid var(--line);border-radius:16px;overflow:hidden;box-shadow:0 1px 2px rgba(16,24,40,.04);transition:box-shadow .2s ease,transform .2s ease;text-decoration:none}
.jh-card:hover{box-shadow:0 8px 28px rgba(16,24,40,.12);transform:translateY(-1px)}
.jh-image-wrap{position:relative;height:240px;overflow:hidden}
@media(min-width:640px){.jh-image-wrap{height:260px}}
@media(min-width:992px){.jh-image-wrap{height:280px}}
.jh-image{width:100%;height:100%;object-fit:cover;display:block;transition:transform .3s ease}
.jh-card:hover .jh-image{transform:scale(1.03)}
.jh-card-body{padding:16px}
.jh-name{margin:0;font-size:16px;font-weight:600;color:var(--ink);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}

/* Detail */
.jh-product{display:grid;grid-template-columns:1fr;gap:24px}
@media(min-width:900px){.jh-product{grid-template-columns:1fr 1fr}}
.jh-detail-media{background:#0f172a08;border:1px solid var(--line);border-radius:16px;overflow:hidden}
.jh-hero{width:100%;height:clamp(240px,50vh,520px);object-fit:cover;display:block}
.jh-thumbs{display:grid;grid-template-columns:repeat(auto-fill, 72px);gap:8px;padding:12px;background:#f8fafc;border-top:1px solid var(--line);justify-content:start;overflow-x:auto;}
.jh-thumb{width:72px;height:72px;object-fit:cover;border-radius:8px;border:2px solid transparent;cursor:pointer}
.jh-thumb--active{border-color:var(--badge)}
.jh-detail-body{position:relative}
.jh-back{border:1px solid var(--line);background:#fff;color:var(--ink);padding:8px 10px;border-radius:8px;cursor:pointer}
.jh-detail-title{margin:12px 0 4px;font-size:22px;font-weight:800;color:var(--ink)}
.jh-rating{color:#475569;font-size:14px;margin-bottom:12px}
.jh-price{font-size:20px;font-weight:800;color:var(--ink)}
.jh-price s{color:#94a3b8;font-weight:500;margin-right:8px}
.jh-desc{margin-top:12px;color:#334155;line-height:1.5}
.jh-field{margin-top:14px}
.jh-label{display:block;font-size:12px;color:#475569;margin-bottom:6px}
.jh-input{width:96px;padding:8px 10px;border:1px solid var(--line);border-radius:8px}
.jh-input.wide{width:100%}
.jh-sizes{display:flex;flex-wrap:wrap;gap:8px;margin-top:6px}
.jh-chip{border:1px solid var(--line);padding:6px 10px;border-radius:999px;font-size:13px;color:var(--ink);background:#fff;cursor:pointer}
.jh-chip--active{background:#eef2ff;border-color:#c7d2fe}
.jh-tags{margin-top:10px;display:flex;flex-wrap:wrap;gap:8px}
.jh-tag{background:#eef2ff;color:#3730a3;border-radius:999px;padding:4px 10px;font-size:12px}
.jh-actions{display:flex;gap:12px;margin-top:18px}
.jh-btn{padding:10px 14px;border-radius:10px;border:1px solid var(--brand);background:var(--brand);color:#fff;cursor:pointer;font-weight:700}
.jh-btn--ghost{background:#fff;color:var(--brand)}
.jh-link{background:none;border:none;padding:0;margin:0;color:var(--ink);text-decoration:underline;cursor:pointer}
.jh-link.danger{color:#b91c1c}

/* Cart */
.jh-cart-list{display:grid;gap:12px;margin-top:14px;list-style:none;padding-left:0;margin-left:0}
.jh-cart-item{display:grid;grid-template-columns:96px 1fr auto auto;gap:12px;align-items:center;border:1px solid var(--line);border-radius:12px;padding:10px;background:#fff}
.jh-cart-img{width:96px;height:72px;object-fit:cover;border-radius:8px}
.jh-cart-main{display:grid;gap:4px}
.jh-cart-name{font-weight:700;color:var(--ink)}
.jh-cart-meta{color:#475569;font-size:13px}
.jh-cart-price{font-weight:700}
.jh-cart-qty{display:grid;gap:6px;justify-items:end}
.jh-cart-summary{margin-top:16px;border-top:1px solid var(--line);padding-top:12px}
.jh-cart-row{display:flex;justify-content:space-between;align-items:center;padding:6px 0}
.jh-cart-row.small{font-size:12px;color:#475569}
.jh-cart-row.total strong{font-size:20px}
.jh-card.jh-coupon,.jh-card.jh-ship{margin-top:16px;padding:16px}
.jh-coupon-row{display:grid;grid-template-columns:1fr auto auto;gap:12px;align-items:end}
.jh-ship-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px}
.jh-note{margin-top:8px;color:#475569;font-size:12px}

/* Checkout */
.jh-checkout-grid{display:grid;grid-template-columns:1fr;gap:16px}
@media(min-width:992px){.jh-checkout-grid{grid-template-columns:1.2fr 1.2fr .8fr}}
.jh-card.jh-pane{margin-bottom:30px;}
.jh-pane{padding:16px}
.jh-pane-title{margin:0 0 10px 0;font-size:18px;font-weight:800;color:var(--ink)}
.jh-form-grid{display:grid;gap:12px}
.jh-two{display:grid;grid-template-columns:1fr 1fr;gap:12px}
.jh-three{display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px}
.jh-mini-list{list-style:none;padding:0;margin:0 0 8px 0;display:grid;gap:6px}
.jh-mini-row{display:flex;justify-content:space-between;align-items:center}
.jh-pay-methods{display:flex;gap:12px;flex-wrap:wrap;margin-bottom:10px}
.jh-radio{display:inline-flex;align-items:center;gap:8px;border:1px solid var(--line);padding:8px 10px;border-radius:999px;cursor:pointer}
.jh-radio input{accent-color:#111}
.jh-radio.checked{background:#f8fafc}
.jh-pay{background:#003087;border-color:#003087}
.jh-apple{background:#111;border-color:#111}
 #square-card-container .sq-card-wrapper{display:block !important;flex:0 0 auto !important;}

/* Processing overlay */
.jh-processing-overlay{position:fixed;inset:0;background:rgba(15,23,42,.55);display:flex;align-items:center;justify-content:center;z-index:1200}
.jh-processing-card{width:min(420px,92vw);background:#fff;border:1px solid var(--line);border-radius:16px;box-shadow:0 20px 60px rgba(2,8,23,.35);padding:20px;display:grid;gap:10px;justify-items:center;text-align:center}
.jh-spinner{width:44px;height:44px;border-radius:50%;border:4px solid #e5e7eb;border-top-color:var(--brand);animation:jh-spin .9s linear infinite}
.jh-processing-title{font-weight:800;color:var(--ink)}
.jh-processing-sub{color:var(--muted);font-size:12px}
@keyframes jh-spin{to{transform:rotate(360deg)}}

/* Footer */
.jh-footer{border-top:1px solid var(--line);background:#fff;margin-top:28px}
.jh-footer-inner{max-width:1320px;margin:0 auto;padding:44px 35px 35px}
.jh-footer-grid{display:grid;row-gap:22px;column-gap:100px}
@media(min-width:900px){.jh-footer-grid{grid-template-columns:1.3fr 1fr .8fr;align-items:start}}
.jh-footer-col{display:block}
@media(max-width:899px){.jh-footer-col--signup{order:1}.jh-footer-col--social{order:2}.jh-footer-col--help{order:3}}
.jh-footer-title{font-weight:900;color:var(--ink);margin-bottom:10px}
.jh-footer-text{color:var(--muted);font-size:13px;line-height:1.5}
.jh-footer-form{display:flex;gap:10px;margin-top:12px;flex-wrap:wrap}
.jh-footer-input{flex:1;min-width:220px;padding:10px 12px;border:1px solid var(--line);border-radius:10px}
.jh-footer-links{display:grid;gap:8px}
.jh-footer-link{background:none;border:none;padding:0;margin:0;color:var(--ink);text-decoration:underline;cursor:pointer;text-align:left;font-size:13px}
.jh-footer-bottom{margin-top:18px;padding-top:18px;border-top:1px solid var(--line);display:flex;justify-content:space-between;align-items:center;gap:12px}
.jh-footer-small{color:#94a3b8;font-size:12px}

/* Mini Cart Drawer */
.jh-drawer-overlay{position:fixed;inset:0;background:rgba(15,23,42,.55);display:flex;justify-content:flex-end;z-index:1000}
.jh-drawer{width:min(420px,90vw);height:100%;background:#fff;box-shadow:-20px 0 60px rgba(2,8,23,.35);display:flex;flex-direction:column}
.jh-drawer-head{display:flex;justify-content:space-between;align-items:center;padding:12px 16px;border-bottom:1px solid var(--line)}
.jh-drawer-title{font-weight:800;color:var(--ink)}
.jh-close{border:none;background:#0f172a;color:#fff;width:36px;height:36px;border-radius:50%;cursor:pointer;font-size:22px;line-height:36px;text-align:center}
.jh-empty{padding:24px;color:#475569}
.jh-drawer-list{flex:1;overflow:auto;padding:12px;list-style:none;margin:0}
.jh-drawer-item{display:grid;grid-template-columns:72px 1fr auto;gap:10px;align-items:center;border-bottom:1px solid var(--line);padding:8px 0}
.jh-drawer-img{width:72px;height:54px;object-fit:cover;border-radius:8px}
.jh-drawer-main{display:grid;gap:4px}
.jh-drawer-name{font-weight:700;color:var(--ink)}
.jh-drawer-meta{color:#475569;font-size:12px}
.jh-drawer-price{font-weight:700}
.jh-drawer-qty{display:grid;gap:6px;justify-items:end}
.jh-drawer-summary{border-top:1px solid var(--line);padding:12px}
`;

export default baseCss;
